import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { KnowledgeBaseService, KBCategory, KBArticle } from '../../services/knowledge-base.service';

@Component({
  selector: 'app-kb-article-new',
  templateUrl: './kb-article-new.component.html',
  styleUrls: ['./kb-article-new.component.css']
})
export class KbArticleNewComponent implements OnInit {
  categories: KBCategory[] = [];
  article: Partial<KBArticle> = {
    title: '',
    content: '',
    categoryId: null,
    documentType: 'SOP',
    isPublished: true
  };
  saving = false;
  error = '';

  constructor(
    private router: Router,
    private kb: KnowledgeBaseService
  ) {}

  ngOnInit() {
    this.kb.getCategories().subscribe(cats => this.categories = cats);
  }

  save() {
    this.error = '';
    if (!this.article.title?.trim()) { this.error = 'Title is required.'; return; }
    if (!this.article.categoryId) { this.error = 'Category is required.'; return; }
    if (!this.article.content?.trim()) { this.error = 'Content is required.'; return; }

    this.saving = true;
    this.kb.saveArticle(this.article as KBArticle, 'Initial creation').subscribe({
      next: (saved) => {
        this.saving = false;
        this.router.navigate(['/knowledge-base', saved.categorySlug, saved.slug]);
      },
      error: () => {
        this.saving = false;
        this.error = 'Failed to save. Please try again.';
      }
    });
  }

  cancel() {
    this.router.navigate(['/knowledge-base']);
  }
}
